import _ from 'lodash'

import {
  filterKeys,
  filtersRequiringDestinations,
} from '../../configuration/filtering'

import {
  FETCH_COUNTRIES_SUCCESS,
  FETCH_DESTINATIONS_SUCCESS,
  FETCH_FAMOUS_ROUTES_SUCCESS,
  FETCH_NATIONAL_PARKS_SUCCESS,
  FETCH_REGIONS_SUCCESS,
  FETCH_TRAINS_SUCCESS,
  FETCH_VACATION_TYPES_SUCCESS,
} from '../actions/fetchContent'

const initialState = {}

export default function fetchContent(state = initialState, action) {
  switch (action.type) {
    case FETCH_COUNTRIES_SUCCESS:
      return Object.assign({}, state, {
        [`${filterKeys.countries}`]: action.payload,
      })
    case FETCH_DESTINATIONS_SUCCESS:
      return Object.assign({}, state, {
        [`${filterKeys.destinationIncludes}`]: action.payload,
      })
    case FETCH_FAMOUS_ROUTES_SUCCESS:
        return Object.assign({}, state, {
          [`${filterKeys.famousRoutes}`]: action.payload,
        })
    case FETCH_NATIONAL_PARKS_SUCCESS:
      return Object.assign({}, state, {
        [`${filterKeys.nationalParks}`]: action.payload,
      })
    case FETCH_REGIONS_SUCCESS:
      return Object.assign({}, state, {
        [`${filterKeys.regions}`]: action.payload,
      })
    case FETCH_TRAINS_SUCCESS:
      return Object.assign({}, state, {
        [`${filterKeys.trains}`]: action.payload,
      })
    case FETCH_VACATION_TYPES_SUCCESS:
      return Object.assign({}, state, {
        [`${filterKeys.vacationTypes}`]: action.payload,
      })
    default:
      return state
  }
}

export const getContentData = state => _.get(state, 'contentData')
export const getContentByKey = (state, key) => {
  // if filter is destination related, return destination includes (all destinations)
  if (_.includes(filtersRequiringDestinations, key)) {
    return _.get(state, `contentData[${filterKeys.destinationIncludes}]`)
  }
  return _.get(state, `contentData[${key}]`)
}

export const getPickedContentByKeys = (state, keys) => {
  return _.reduce(keys, (contentMap, key) => ({
    ...contentMap,
    [`${key}`]: getContentByKey(state, key)
  }), {})
}
